
const AlertIcon = ({ color = "var(--primary-color)", width, height, ...props}) => (
    <svg    
        viewBox="0 0 20 20"
        width={width || 20}
        height={height || 20}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M10 13.615a.208.208 0 1 0 .002.416.208.208 0 0 0-.003-.416"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="m6.178 17.294-3.19-3.19a1.667 1.667 0 0 1-.488-1.179V7.64c0-.442.176-.866.488-1.179l3.19-3.19a1.667 1.667 0 0 1 1.179-.488h5.285c.442 0 .866.176 1.179.488l3.19 3.19c.313.313.489.737.489 1.179v5.285c0 .442-.176.866-.488 1.179l-3.679 3.679H7.357c-.442 0-.866-.176-1.179-.488v0Z"
            clipRule="evenodd"
        />
        <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={0.72}
            strokeWidth={1.5}
            d="M10 10.699V6.532"
        />
    </svg>
)

export default AlertIcon
